import React from 'react';
import styled, { css } from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

const NoDataBox = styled('div')<any>`
  padding: ${({ theme }): string => theme.spacing.large};
  text-align: center;
  color: ${({ theme }): string => theme.CasperGrey};
  background: white;
  margin: 0 ${({ theme }): string => theme.large};
  font-size: ${modularScale(-1)};

  ${({ isSmallScreen }): any =>
    !isSmallScreen &&
    css`
      box-shadow: 0 0.25em 1em 0 rgba(0, 0, 0, 0.05);
    `};

  @media screen and (min-width: 40em) {
    max-width: 25em;
  }

  h3 {
    font-size: ${modularScale(2)};
    font-weight: normal;
    margin-top: 0;
  }
`;

const NoData = (props: any): any => {
  const { children, className, isSmallScreen } = props;
  return (
    <NoDataBox className={className} isSmallScreen={isSmallScreen}>
      {children}
    </NoDataBox>
  );
};

export default NoData;
